"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeytipContent = void 0;
var Utilities_1 = require("../../Utilities");
var KeytipContent_base_1 = require("./KeytipContent.base");
var Keytip_styles_1 = require("./Keytip.styles");
exports.KeytipContent = Utilities_1.styled(KeytipContent_base_1.KeytipContentBase, Keytip_styles_1.getStyles, undefined, {
    scope: 'KeytipContent',
});
//# sourceMappingURL=KeytipContent.js.map